import * as THREE from 'three';
import footerFragment from './shaders/footer/fragment.glsl';
import vertexFragment from './shaders/footer/vertex.glsl';
import { GLTFLoader } from 'three/examples/jsm/Addons.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl');

// Scene
const scene = new THREE.Scene();

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
};

/**
 * FOOTER PARAMS
 */
const footerHeight = sizes.height;

// Position the plane at the end of the scroll for the footer
window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    footer.position.y = scrollY - maxScroll - ((window.innerHeight - footerHeight) / 2);
    modelPlane.position.y = scrollY;
});
window.addEventListener('resize', () => {
    isMobile = window.matchMedia("(orientation: portrait)").matches;
    controls.enableZoom = isMobile;
    updateZoomListener();

    // --- Update sizes ---
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    const aspect = sizes.width / sizes.height;

    // --- Update renderer ---
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    // --- Update orthographic camera (2D scene) ---
    const cameraWidth = sizes.width;
    const cameraHeight = cameraWidth / aspect;

    camera.left = -cameraWidth / 2;
    camera.right = cameraWidth / 2;
    camera.top = cameraHeight / 2;
    camera.bottom = -cameraHeight / 2;
    camera.updateProjectionMatrix();

    // --- Resize footer ---
    footer.scale.set(sizes.width, footerHeight, 1);
    footerMaterial.uniforms.u_size.value.set(sizes.width, footerHeight, sizes.width / footerHeight);

    const scrollY = window.scrollY;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    footer.position.y = scrollY - maxScroll - ((window.innerHeight - footerHeight) / 2);

    // --- Resize model plane ---
    modelPlane.scale.set(sizes.width, sizes.height, 1);

    // --- Update model camera ---
    modelCamera.aspect = aspect;
    modelCamera.updateProjectionMatrix();
    // --- Update FBO ---
    fbo.setSize(sizes.width, sizes.height);
    controls.update();
});


/**
 * model in a plane
 */
const modelScene = new THREE.Scene()
modelScene.background = new THREE.Color('#f1f1ef')
const modelCamera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
modelCamera.position.set(0, 1, 4)
const fbo = new THREE.WebGLRenderTarget(sizes.width, sizes.height)

// set the plane
const modelPlane = new THREE.Mesh(
    new THREE.PlaneGeometry(1, 1),
    new THREE.MeshBasicMaterial({ map: fbo.texture })
);
modelPlane.scale.x = sizes.width;
modelPlane.scale.y = sizes.height;
// ! here position the plane in pixel height (0 is equivalent to top: 0; in css) CARE (100 is equivalent to top: -100; in css) need to invert the values
modelPlane.position.y = 0;

scene.add(modelPlane)
// lazy loading 
let modelLoaded = false;


function loadModel() {
    const loader = new GLTFLoader();

    loader.load(
        // '/models/nube.glb',
        'https://espaciolanube.com/uploads/Nube2.gltf',
        (gltf) => {

            const model = gltf.scene;
            model.traverse((child) => {
                if (child.isMesh) {
                    child.material = new THREE.MeshBasicMaterial({
                        color: '#e0e0dd',
                        wireframe: true
                    });
                }
            });
            model.rotation.y = -Math.PI * 0.5;
            modelScene.add(model);
        },
        undefined,
        (error) => {
            console.error('Erreur chargement GLTF :', error);
        }
    );
}



/**
 * Camera
 */
const camera = new THREE.OrthographicCamera(
    -sizes.width / 2,
    sizes.width / 2,
    sizes.height / 2,
    -sizes.height / 2,
    -1000,
    1000
);
camera.position.set(0, 0, 4);
scene.add(camera);


/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
});
// Background color
renderer.setClearColor(0x777777);
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
// controls
const controls = new OrbitControls(modelCamera, renderer.domElement);
controls.enabled = true;
controls.autoRotate = true
// !rotation speed
controls.autoRotateSpeed = 0.5
controls.enableDamping = true
controls.dampingFactor = 0.04
controls.enablePan = false
controls.maxDistance = 8
controls.minDistance = 2
controls.maxPolarAngle = Math.PI / 2;
controls.minPolarAngle = 0;
//! enableZoom on mobile not on desktop, modify here condition relatively to your css gesture.
let isMobile = window.matchMedia("(orientation: portrait)").matches;
controls.enableZoom = isMobile;
// keyboard gestures
const zoomStep = 0.5;
let zoomDistanceTarget = modelCamera.position.distanceTo(controls.target);
const minDistance = controls.minDistance;
const maxDistance = controls.maxDistance;

function keyDownZoomListener(e) {
    switch (e.key) {
        case '+': // zoom in
            zoomDistanceTarget = Math.max(minDistance, zoomDistanceTarget - zoomStep);
            break;
        case '-': // zoom out
            zoomDistanceTarget = Math.min(maxDistance, zoomDistanceTarget + zoomStep);
            break;
    }
}

function updateZoomListener() {
    window.removeEventListener('keydown', keyDownZoomListener);
    if (!isMobile) {
        window.addEventListener('keydown', keyDownZoomListener);
    }
}
updateZoomListener();



controls.update();

/**
 * Material
 */
const footerMaterial = new THREE.ShaderMaterial({
    side: THREE.DoubleSide,
    fragmentShader: footerFragment,
    vertexShader: vertexFragment,
    uniforms: {
        u_bgColor: new THREE.Uniform(new THREE.Vector3(0.949, 0.949, 0.941)),
        u_sphereCol: new THREE.Uniform(new THREE.Vector3(0.88, 0.88, 0.87)),
        u_size: new THREE.Uniform(new THREE.Vector3(sizes.width, footerHeight, sizes.width / footerHeight)),
        u_pixelRatio: new THREE.Uniform(window.devicePixelRatio),
        u_time: new THREE.Uniform(0),
        u_camDist: new THREE.Uniform(-3),
        u_mouse: new THREE.Uniform(new THREE.Vector3(999, 999, 0)),
    },
});

/**
 * !Objects
 */

//! Footer plane
const footer = new THREE.Mesh(
    new THREE.PlaneGeometry(1, 1), // Fixed height now
    footerMaterial
);
footer.scale.x = sizes.width;
footer.scale.y = footerHeight;
footer.position.x = 0;
const scrollY = window.scrollY;
const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
footer.position.y = scrollY - maxScroll - ((window.innerHeight - footerHeight) / 2);

scene.add(footer);

/**
 * !Mouse Gesture
 */
// Add Raycaster for mouse interaction
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2(-3, -3);
let prevMouse = new THREE.Vector2(-3, -3);
const smoothFactor = 0.1;

// Handle mouse move to update the raycaster's mouse position
window.addEventListener('pointermove', (event) => {
    // Normalize the mouse position
    mouse.x = (event.clientX / sizes.width) * 2 - 1;
    mouse.y = -(event.clientY / sizes.height) * 2 + 1;
});

/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {
    // update controls if hovering the model Screen
    // ! update the lerp only on desktop to alow touch zoom on mobile
    if (!isMobile) {
        const currentDirection = new THREE.Vector3().subVectors(modelCamera.position, controls.target).normalize();
        const currentDistance = modelCamera.position.distanceTo(controls.target);
        const interpolatedDistance = THREE.MathUtils.lerp(currentDistance, zoomDistanceTarget, 0.1);
        modelCamera.position.copy(controls.target).add(currentDirection.multiplyScalar(interpolatedDistance));
    } else {
        // no update
    }
    const intersectmodelPlane = raycaster.intersectObject(modelPlane);
    // this line allow touch gesture only if raycast detect the plane with the model under. if not, we can scroll
    controls.enabled = intersectmodelPlane.length ? true : false

    controls.update();

    // 
    const elapsedTime = clock.getElapsedTime();
    footerMaterial.uniforms.u_time.value = elapsedTime * 0.5;

    // Interpolate mouse position between previous and current position
    footerMaterial.uniforms.u_mouse.value.x = prevMouse.x * (1 - smoothFactor) + mouse.x * smoothFactor;
    footerMaterial.uniforms.u_mouse.value.y = (prevMouse.y * (1 - smoothFactor) + mouse.y * smoothFactor);

    // Update previous mouse position
    prevMouse.copy(footerMaterial.uniforms.u_mouse.value);

    // Update Raycaster
    raycaster.setFromCamera(footerMaterial.uniforms.u_mouse.value, camera);
    const intersects = raycaster.intersectObject(footer);
    if (intersects.length > 0) {

        const x = intersects[0].uv.x;
        const y = intersects[0].uv.y;
        footerMaterial.uniforms.u_mouse.value.x = x * 2 - 1;
        footerMaterial.uniforms.u_mouse.value.y = y * 2 - 1;
    } else {
        footerMaterial.uniforms.u_mouse.value.x = 999;
        footerMaterial.uniforms.u_mouse.value.y = 999;
    }


    if (!modelLoaded && modelPlane.position.y < camera.position.y + sizes.height / 2 &&
        modelPlane.position.y > camera.position.y - sizes.height / 2) {
        modelLoaded = true;
        loadModel();
    }


    // Render the scene
    renderer.setRenderTarget(fbo)
    renderer.render(modelScene, modelCamera);
    renderer.setRenderTarget(null)
    renderer.render(scene, camera);

    // Request the next frame
    window.requestAnimationFrame(tick);
};

tick();
